export default function AppVersion() {
    const version = process.env.REACT_APP_VERSION;

    return (
        <div style={{ 
            fontSize: 14, 
            opacity: 0.6 ,
            position: 'absolute',
            bottom: 10,
            right: 10,
        }}>
            Versione {version}
        </div>
    );
}